import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { type, colors, space } from '../theme';
import QACard from '../components/QACard';
import SectionTitle from '../components/SectionTitle';

// Stacks the live-meeting Q&A by speaker — seller-asked questions first
// (discovery / qualification), then prospect-asked (objections / info).
// Both are transcript context, not training; no scoring.
const SubsectionHeader = ({ children, count }) => (
  <Text style={[type.cardTitle, { color: colors.ink, marginTop: space.md, marginBottom: space.sm }]}>
    {children} <Text style={[type.cardTitle, { color: colors.muted }]}>({count})</Text>
  </Text>
);

const EmptyPlaceholder = ({ label }) => (
  <Text style={[type.body, { color: colors.muted, fontStyle: 'italic', marginBottom: space.md }]}>
    {label}
  </Text>
);

const QABreakdownSection = ({ report }) => {
  const qa = report.qa || [];
  if (!qa.length) return null;

  const sellerAsked = qa.filter(q => q.askedBy === 'seller');
  const prospectAsked = qa.filter(q => q.askedBy !== 'seller');

  return (
    <View>
      <View wrap={false}>
        <SectionTitle>Question Breakdown</SectionTitle>
        <Text style={[type.body, { color: colors.muted, marginBottom: space.sm }]}>
          Every substantive Q&amp;A exchange captured from the transcript.
        </Text>
        <SubsectionHeader count={sellerAsked.length}>Questions you asked</SubsectionHeader>
        {sellerAsked.length === 0
          ? <EmptyPlaceholder label="No seller-asked questions detected." />
          : <QACard qa={sellerAsked[0]} index={0} />
        }
      </View>
      {sellerAsked.slice(1).map((q, i) => <QACard key={`s${i + 1}`} qa={q} index={i + 1} />)}

      <View wrap={false}>
        <SubsectionHeader count={prospectAsked.length}>Questions they asked</SubsectionHeader>
        {prospectAsked.length === 0
          ? <EmptyPlaceholder label="No prospect-asked questions detected." />
          : <QACard qa={prospectAsked[0]} index={0} />
        }
      </View>
      {prospectAsked.slice(1).map((q, i) => <QACard key={`p${i + 1}`} qa={q} index={i + 1} />)}
    </View>
  );
};

export default QABreakdownSection;
